import { z } from "zod";
import { ulidSchema } from "./schemas.js";
export const customerRequestRouteClassSchema = z.enum([
    "LIBRARY_READ",
    "BOOK_EDITION_READ",
    "STUDIO_READ",
    "STUDIO_SAVE",
    "CHAPTER_READ",
    "CHAPTER_SAVE",
    "NATIVE_BOOK",
]);
export const adminRequestEvidenceCommandSchema = z
    .object({
    view: z.literal("REQUEST_EVIDENCE"),
    ticketId: ulidSchema,
    reference: z.string().uuid(),
})
    .strict();
export const adminRequestEvidenceResponseSchema = z
    .object({
    data: z
        .object({
        ticketId: ulidSchema,
        evidence: z.discriminatedUnion("state", [
            z.object({ state: z.literal("UNAVAILABLE") }).strict(),
            z
                .object({
                state: z.literal("AVAILABLE"),
                reference: z.string().uuid(),
                routeClass: customerRequestRouteClassSchema,
                status: z.number().int().min(400).max(599),
                code: z.string().regex(/^[A-Z][A-Z0-9_]{0,119}$/),
                occurredAt: z.string().datetime(),
                scope: z.enum(["CUSTOMER_ACCOUNT", "TICKET_BOOK"]),
            })
                .strict(),
        ]),
    })
        .strict(),
})
    .strict();
//# sourceMappingURL=admin-request-evidence.js.map